<ng-container [formGroup]="formData">
  <div class="mu-assign-users-role">
    <div class="p-field mu-checkbox">
      <p-checkbox [id]="controlName" [value]="rolesList?.roleId" [name]="controlName" [formControlName]="controlName"></p-checkbox>
    </div>
    <div class="mu-assign-users-role-concept">
      <span class="mu-assign-role-title">{{ rolesList?.name | translate }}</span>
      <p>{{ rolesList?.description | translate }}</p>
    </div>
  </div>
</ng-container>
